import { createSelector } from "reselect"
import lodash from "lodash"

export const makeSelectState = () => state => state.AddressModal

export const makeSelectIsOpen = () =>
  createSelector(makeSelectState(), state => state.isOpen)
export const makeSelectIsLoading = () =>
  createSelector(makeSelectState(), state => state.isLoading)
export const makeSelectResult = () =>
  createSelector(makeSelectState(), state => state.result)
export const makeSelectError = () =>
  createSelector(makeSelectState(), state => state.error)
export const makeSelectAddress = () =>
  createSelector(makeSelectState(), state => state.address)
export const makeSelectIsDelete = () =>
  createSelector(makeSelectState(), state => state.isDelete)
export const makeSelectIsImport = () =>
  createSelector(makeSelectState(), state => state.isImport)
